import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useChecklistServicoItensCadastroViewModel } from "../../viewModels/checklist_servico_itens_cadastro_view_model";
import { Breadcrumbs, Typography, Link, Stack, TablePagination, Alert } from "@mui/material";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateChecklistServicoItensCadastroColumnDefinition } from "./columns";
import { Link as LinkTo } from 'react-router';
import { BackButton } from "../../../../../common/components/back_button";
import { ItemChecklistServico } from "../../../domain/models/item_checklist_servico";
import { ItemChecklistServicoModal } from "./components/item_checklist_servico_modal";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * ChecklistServicoItensCadastro
 */

export const ChecklistServicoItensCadastro = () => {
  const viewModel = useChecklistServicoItensCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateChecklistServicoItensCadastroColumnDefinition({
      hasObraChecklistServico: viewModel.checklistServico !== undefined && viewModel.checklistServico.hasObraChecklistServico,
      onActionEditar: viewModel.handleItemChecklistServicoModalOpenState,
      onActionDeletar: viewModel.handleItemChecklistServicoDeleteModalOpenState,
    });
  }, [
    viewModel.checklistServico,
    viewModel.handleItemChecklistServicoModalOpenState,
    viewModel.handleItemChecklistServicoDeleteModalOpenState,
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              {
                viewModel.checklistServico && !viewModel.checklistServico.hasObraChecklistServico &&
                <div className="w-[200px] ">
                  <PrimaryButton
                    buttonColor="red"
                    startIcon={<DynamicIcon nameIcon="Delete" size={25} className="text-white" />}
                    onMouseDown={_ => viewModel.handleSelectedChecklistServicoDeleteModalOpenState(true)}>
                    Excluir Selecionados
                  </PrimaryButton>
                </div>
              }
              {
                viewModel.checklistServico && !viewModel.checklistServico.hasObraChecklistServico &&
                <div className="w-[115px] ">
                  <PrimaryButton
                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                    onMouseDown={_ => viewModel.handleItemChecklistServicoModalOpenState(null, true)}>
                    Novo Item
                  </PrimaryButton>
                </div>
              }

              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/ChecklistServico_lista`}>Checklist de Serviço</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Itens do Checklist de Serviço
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Itens do Checklist de Serviço</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">
            </div>
          </div>

          {
            viewModel.checklistServico &&
            <div className="w-full flex flex-col gap-0">
              <div className="w-full flex flex-row items-center">
                <span className="text-black dark:text-white font-bold text-lg">
                  {viewModel.checklistServico.codigo} | {viewModel.checklistServico.descricao}
                </span>
              </div>
              {
                (viewModel.checklistServico.revisao && viewModel.checklistServico.revisao.length > 0) &&
                <span className="text-gray-600 dark:text-gray-300 font-bold text-base">
                  Revisão: {viewModel.checklistServico.revisao}
                </span>
              }

            </div>
          }
          {/* iNFORMAÇÕES DO AMBIENTE SELECIONADO */}
          {
            viewModel.selectedChecklistServicoAmbiente &&
            <div className="w-full flex flex-col gap-0">
              <div className="w-full flex flex-row items-center">
                <span className="text-black dark:text-white font-bold text-lg">
                  Ambiente: {viewModel.selectedChecklistServicoAmbiente.ordem} | {viewModel.selectedChecklistServicoAmbiente.descricao}
                </span>
              </div>
              {
                (viewModel.checklistServico && viewModel.checklistServico.hasObraChecklistServico) &&
                <div className="w-full mt-4">
                  <Alert severity="error">
                    Não é possível incluir ou excluir itens do check list, pois ele está vinculado à alguma obra.
                  </Alert>
                </div>
              }
            </div>
          }

        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="checklist_servico_itens_cadastro"
                    disableColumnMenu={false}
                    checkboxSelection={true}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    getRowId={(row: ItemChecklistServico) => row.idItemChecklistServico}
                    getRowHeight={() => 'auto'}
                    textSize="pequeno"
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.itensChecklistServico}
                    rowCount={viewModel.itensChecklistServico.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ItemChecklistServicoModal
        open={viewModel.itemChecklistServicoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedItemChecklistServico={viewModel.selectedItemChecklistServico}
        onClose={viewModel.handleItemChecklistServicoModalOpenState}
        onSubmit={viewModel.handleItemChecklistServicoSubmit}
      />

      <DeleteDialog
        open={viewModel.itemChecklistServicoDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleItemChecklistServicoDeleteModalOpenState(null, false)}
        onDelete={viewModel.handleItemChecklistServicoDeleteSubmit}
      />

      <DeleteDialog
        open={viewModel.selectedChecklistServicoDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir estes itens?'
        onClose={() => viewModel.handleSelectedChecklistServicoDeleteModalOpenState(false)}
        onDelete={viewModel.handleSelectedChecklistServicoDeleteSubmit}
      />
    </>
  );
}